import { LegalNoticeComponent } from './legal-notice/legal-notice.component';
import { ProfilComponent } from './profil/profil.component';
import { ContactComponent } from './contact/contact.component';
import { PipesModule } from '@app/pipes/pipes.module';
import { RestaurantComponent } from './restaurant/restaurant.component';
import { CommonComponentsModule } from '@app/modules/common/common.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { routing } from './views.routing';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app/modules/shared/shared.module';
import { AbsolutePathModule } from '@app/pipes/absolute-path/absolute-path.module';
import { CgvComponent } from './cgv/cgv.component';
import { HelpycurrencyModule } from '@app/pipes/helpycurrency/helpycurrency.module';
import { OrdersComponent } from './orders/orders.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        routing,
        SharedModule,
        CommonComponentsModule,
        PipesModule,
        AbsolutePathModule,
        HelpycurrencyModule
    ],
    declarations: [
        RestaurantComponent,
        ContactComponent,
        ProfilComponent,
        OrdersComponent,
        CgvComponent,
        LegalNoticeComponent
    ],
    exports: [
    ]
})

export class ViewsModule {

}
